<template>
    <Tracking/>
</template>

<script>
import Tracking from "./Tracking";

export default {
  name: "Invite",
  data: function() {
    return {
      invite: this.$route.params.invite
    };
  },
  created: function() {
    if (this.invite) {
      localStorage.invite = this.invite;
    }

    window.location.href = "/";
  },
  components: { Tracking }
};
</script>